import { AvailableArchivationDateRange } from '../types/available-archivation-dates';
import { AvailableProjectArchivationDateResponse } from '../types/dto/response/available-project-archivation-date-response';
import { AvailableProjectUnarchivationDateResponse } from '../types/dto/response/available-project-unarchivation-date-response';

/**
 * Maps available archivation date response DTO to domain model.
 * Converts ISO date strings to Date objects.
 */
export const mapAvailableArchivationDateRangeFromDTO = (
  dto: AvailableProjectArchivationDateResponse
): AvailableArchivationDateRange => {
  return {
    startDate: dto.startDate ? new Date(dto.startDate) : null,
    endDate: dto.endDate ? new Date(dto.endDate) : null,
  };
};

/**
 * Maps available unarchivation date response DTO to domain model.
 * Converts ISO date string to Date object.
 */
export const mapAvailableUnarchivationDateFromDTO = (
  dto: AvailableProjectUnarchivationDateResponse
): Date | null => {
  return dto.availableUnarchivationDate ? new Date(dto.availableUnarchivationDate) : null;
};
